/**
 * Returns an onBlur handler that trims leading/trailing whitespace and
 * optionally propagates the change via the provided onChange handler so that
 * external form libraries (e.g. react-hook-form) receive the updated value.
 */
export const createInputTrimHandler = (
  onBlur?: React.FocusEventHandler<HTMLInputElement>,
): React.FocusEventHandler<HTMLInputElement> => {
  return (e) => {
    e.target.value = e.target.value.trim();

    onBlur?.(e);
  };
};
